<template>
    <div class="sideblock-delivery-point-item" v-on:click="select">
        <div class="sideblock-delivery-point-item__address-container">
            <div>
                <div>{{deliveryAddress}}</div>
                <div>{{deliveryPoint.code}}</div>
<!--                <div>{{deliveryPointType}}</div>-->
            </div>
            <div class="sideblock-delivery-point-item__map" v-if="deliveryMapLink">
                <a :href="deliveryMapLink" target="_blank" class="sideblock-delivery-point-item__map-link" v-on:click.stop>
                    На карте
                </a>
            </div>
        </div>
        <br/>
        <div>{{deliveryPoint.work_time}}</div>
        <div v-if="deliveryTimeFormatted">Срок доставки: {{deliveryTimeFormatted}}</div>
        <br/>
        <div class="sideblock-delivery-point-item__trigger">
            Выбрать
        </div>
    </div>
</template>

<script>
export default {
    name: 'sideblock-delivery-point-item',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        checkoutData() {
            return this.$store.state.checkout.data;
        },
        deliveryPoint() {
            return this.item;
        },
        deliveryPointType() {
            return this.deliveryPoint.type === 'PVZ'
                ? 'Пункт выдачи'
                : (this.deliveryPoint.type === 'POSTAMAT' ? 'Постамат' : '');
        },
        deliveryAddress() {
            let result = '';
            const location = this.deliveryPoint.location;
            if (location.city) {
                result += location.city + ', ';
            } else if (location.region) {
                result += location.region + ', ';
            }
            return result + location.address;
        },
        deliveryTimeFormatted() {
            return this.$store.getters['checkout/cdekPointDeliveryTimeFormatted'];
        },
        deliveryMapLink() {
            return this.deliveryPoint.location?.address_full
                ? `https://yandex.ru/maps/?text=${this.deliveryPoint.location.address_full}`
                : null;
        },
    },
    methods: {
        select() {
            this.$emit('select', this.deliveryPoint);
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';
.sideblock-delivery-point-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    padding: 16px 29px 16px 20px;
    border-top: 1px solid @color-gray-darkest;

    background-color: @color-gray-lightest;

    cursor: pointer;

    transition: background-color @duration-fast @easing-default;

    &:last-child {
        border-bottom: 1px solid @color-gray-darkest;
    }
    &:hover,
    &._active {
        background-color: @color-accent-yellow;
    }
    &__trigger {
        .mixin-link-decoration();
    }
    &__address-container {
        display: flex;
        justify-content: space-between;
        gap: 20px;
        width: 100%;
    }
    &__map {
        flex-shrink: 0;
    }
    &__map-link {
        .mixin-link-decoration();
    }
}

</style>
